import { apiService as api } from '@/store/apiService';

export const addTagTypes = [
	'settings_account',
	'settings_notification',
	'settings_security'
] as const;
const injectedRtkApi = api
	.enhanceEndpoints({
		addTagTypes
	})
	.injectEndpoints({
		endpoints: (build) => ({
			updateAccountSettings: build.mutation<UpdateAccountSettingsApiResponse, UpdateAccountSettingsApiArg>({
				query: (queryArg) => ({
					url: `user/update`,
					method: 'POST',
					body: queryArg
				}),
				invalidatesTags: ['settings_account']
			}),
			// Notification settings - TODO: Update with actual Laravel endpoint
			getNotificationSettings: build.query<GetNotificationSettingsApiResponse, GetNotificationSettingsApiArg>({
				query: () => ({ url: `notification-settings` }),
				providesTags: ['settings_notification']
			}),
			updateNotificationSettings: build.mutation<
				UpdateNotificationSettingsApiResponse,
				UpdateNotificationSettingsApiArg
			>({
				query: (queryArg) => ({
					url: `notification-settings`,
					method: 'PUT',
					body: queryArg
				}),
				invalidatesTags: ['settings_notification']
			}),
			// Security settings - TODO: Update with actual Laravel endpoint
			getSecuritySettings: build.query<GetSecuritySettingsApiResponse, GetSecuritySettingsApiArg>({
				query: () => ({ url: `security-settings` }),
				providesTags: ['settings_security']
			}),
			updateSecuritySettings: build.mutation<UpdateSecuritySettingsApiResponse, UpdateSecuritySettingsApiArg>({
				query: (queryArg) => ({
					url: `change-password`,
					method: 'POST',
					body: queryArg
				})
			}),
			// NOTE: Plan billing + team member settings endpoints removed for now (unused in this repo).
		}),
		overrideExisting: false
	});
export type UpdateAccountSettingsApiResponse = unknown;
export type UpdateAccountSettingsApiArg = SettingsAccount;
export type GetNotificationSettingsApiResponse = /** status 200 OK */ SettingsNotifications;
export type GetNotificationSettingsApiArg = void;
export type UpdateNotificationSettingsApiResponse = unknown;
export type UpdateNotificationSettingsApiArg = SettingsNotifications;
export type GetSecuritySettingsApiResponse = /** status 200 OK */ SettingsSecurity;
export type GetSecuritySettingsApiArg = void;
export type UpdateSecuritySettingsApiResponse = {
	success: number;
	error: string;
	data: {
		message: string;
	};
};
export type UpdateSecuritySettingsApiArg = SettingsSecurity;

export type SettingsAccount = {
	name?: string;
	email?: string;
};

export type SettingsNotifications = {
	id: string;
	communication?: boolean;
	security?: boolean;
	meetups?: boolean;
	comments?: boolean;
	mention?: boolean;
	follow?: boolean;
	inquiry?: boolean;
};

export type SettingsSecurity = {
	password_confirmation?: string;
	password?: string;
};

export const {
	useUpdateAccountSettingsMutation,
	useGetNotificationSettingsQuery,
	useUpdateNotificationSettingsMutation,
	useGetSecuritySettingsQuery,
	useUpdateSecuritySettingsMutation
} = injectedRtkApi;
